import type { ReactNode } from "react";
import { createContext, useContext } from "react";

export interface TutoringContextType {
  tutoringId: string;
  themeName: string;
  videoTips: Array<{
    videoId: string;
    previewImage?: string | null | undefined;
  }>;
  claimEvaluation: ({
    tutoringId,
    userAssignmentId,
    userAnswers,
  }: {
    tutoringId: string;
    userAssignmentId: string;
    userAnswers: boolean | boolean[];
  }) => Promise<void>;
}

const TutoringContext = createContext<TutoringContextType | null>(null);

type TutoringProviderProps = TutoringContextType & { children: ReactNode };

export const TutoringProvider = ({
  tutoringId,
  themeName,
  children,
  videoTips,
  claimEvaluation,
}: TutoringProviderProps) => (
  <TutoringContext.Provider value={{ tutoringId, themeName, videoTips, claimEvaluation }}>
    {children}
  </TutoringContext.Provider>
);

export const useTutoringContext = () => {
  const context = useContext(TutoringContext);
  if (!context) throw new Error("useTutoring must be used within TutoringProvider");
  return context;
};
